import { DatePicker } from '@mui/x-date-pickers';
import { Dayjs } from 'dayjs';
import { ReportFilterKey, ReportFilterValue } from 'src/type/report';

type Props = {
  date: Dayjs | null;
  handleFilters: (name: ReportFilterKey, value: ReportFilterValue) => void;
};

export default function ReportMonthlyFilters({ date, handleFilters }: Props) {
  const handleSetDate = (inputDate: Dayjs | null) => {
    const startOfMonth = inputDate?.startOf('month') || null;
    const endOfMonth = inputDate?.endOf('month') || null;

    handleFilters('startDate', startOfMonth);
    handleFilters('endDate', endOfMonth);
  };

  return (
    <DatePicker
      label="เดือน"
      value={date}
      onChange={handleSetDate}
      format="MM/YYYY"
      slotProps={{
        textField: {
          fullWidth: true,
        },
      }}
      openTo="month"
      views={['year', 'month']}
    />
  );
}
